import React from 'react';
import styles from './InterviewCard.module.css';
import { InterviewItem } from './types';
import { ATS_CONSTANTS } from './constants';
import { getRelativeTimeString } from '../../utils/interviewTimeUtils';
import dayjs from 'dayjs';

interface InterviewCardProps {
  interview: InterviewItem;
  sectionType: 'action-needed' | 'upcoming' | 'completed' | 'cancelled' | 'no-show';
  isClosed: boolean;
  onCardClick: (candidate: InterviewItem) => void;
  onUpdateStatus?: (candidate: InterviewItem, status: string) => void;
  onReschedule?: (candidate: InterviewItem) => void;
  onCancelInterview?: (candidate: InterviewItem) => void;
  onGenerateOffer?: (candidate: InterviewItem) => void;
}

const InterviewCard: React.FC<InterviewCardProps> = ({
  interview,
  sectionType,
  isClosed,
  onCardClick,
  onUpdateStatus,
  onReschedule,
  onCancelInterview,
  onGenerateOffer,
}) => {
  const status = interview.interviewDetails?.status || ATS_CONSTANTS.STATUS.SCHEDULED;
  const relativeTime = getRelativeTimeString(
    interview.interviewDetails?.date || '',
    interview.interviewDetails?.time || ''
  );

  return (
    <div
      className={styles.interviewCard}
      onClick={() => onCardClick(interview)}
      data-testid={`interview-card-${interview.id}`}
    >
      <div className={styles.interviewCardHeader}>
        <div className={styles.interviewCardInfo}>
          <p className={styles.interviewCardName} data-testid="interview-card-name">{interview.name}</p>
          <div className={styles.interviewCardMeta}>
            <span className={styles.interviewTime}>
              {dayjs(interview.interviewDetails?.date).format('DD/MM/YYYY')} •{' '}
              {dayjs(`2000-01-01 ${interview.interviewDetails?.time}`).format('hh:mm A')}
            </span>
            {relativeTime && (
              <span className={styles.interviewRelativeTime}>
                ({relativeTime})
              </span>
            )}
          </div>
          <div className={styles.interviewCardVenue}>
            Venue: {interview.interviewDetails?.venue || 'N/A'}
          </div>
        </div>
        <div className={styles.interviewCardStatus}>
        </div>
      </div>
      <div className={styles.interviewCardActions}>
        {status === ATS_CONSTANTS.STATUS.COMPLETED && onGenerateOffer && !isClosed && !interview.offerLetter && (
          <button
            className={styles.generateOfferButton}
            onClick={(e) => {
              e.stopPropagation();
              onGenerateOffer(interview);
            }}
            data-testid="interview-card-generate-offer-button"
          >
            Generate Offer
          </button>
        )}
        {(status === ATS_CONSTANTS.STATUS.CANCELLED || status === ATS_CONSTANTS.STATUS.NO_SHOW) &&

          !isClosed && (
            <button
              className={styles.actionButton}
              onClick={(e) => {
                e.stopPropagation();
                onReschedule?.(interview);
              }}
            data-testid="interview-card-reschedule-button"
            >
              Reschedule
            </button>
          )}
        {(status === ATS_CONSTANTS.STATUS.SCHEDULED || status === ATS_CONSTANTS.STATUS.RESCHEDULED) && !isClosed && (
          <>
            {sectionType === 'action-needed' ? (
              <div className={styles.actionButtonsGrid}>
                <button
                  className={styles.actionButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    onUpdateStatus?.(interview, ATS_CONSTANTS.STATUS.COMPLETED);
                  }}
                  data-testid="interview-card-completed-button"
                >
                  Completed
                </button>
                <button
                  className={styles.actionButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    onUpdateStatus?.(interview, ATS_CONSTANTS.STATUS.NO_SHOW);
                  }}
                  data-testid="interview-card-noshow-button"
                >
                  No Show
                </button>
                <button
                  className={styles.actionButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    onReschedule?.(interview);
                  }}
                  data-testid="interview-card-reschedule-button-2"
                >
                  Reschedule
                </button>
                <button
                  className={styles.actionButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    onCancelInterview?.(interview);
                  }}
                  data-testid="interview-card-cancel-button"
                >
                  Cancel
                </button>
              </div>
            ) : (
              <div className={styles.actionButtonsGrid}>
                <button
                  className={styles.actionButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    onReschedule?.(interview);
                  }}
                    data-testid="interview-card-reschedule-button"
                >
                  Reschedule
                </button>
                <button
                  className={styles.actionButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    onCancelInterview?.(interview);
                  }}
                    data-testid="interview-card-cancel-button"
                >
                  Cancel
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default InterviewCard;
